import { render, staticRenderFns } from "./LogicalAxiomeMinCardinality.vue?vue&type=template&id=228c7ff6"
import script from "./LogicalAxiomeMinCardinality.vue?vue&type=script&lang=js"
export * from "./LogicalAxiomeMinCardinality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports